import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function numebrsOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value as string;
    const isValid = /^[0-9\s]+$/.test(value);
    return isValid ? null : { numbersOnly: true };
  };
}
